import { loadNews } from "./api";
import { escapeHtml, formatDate, renderMedia } from "./render";

export async function initNews(): Promise<void> {
  const root = document.getElementById("diario");
  if (!root) return;
  const items = (await loadNews())
    .filter((item) => item.published)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));

  if (!items.length) {
    root.innerHTML = `<p class="empty">Todavía no hay novedades.</p>`;
    return;
  }

  root.innerHTML = items
    .map(
      (item) => `<article>
        <time datetime="${item.createdAt}">${formatDate(item.createdAt)}</time>
        <div>
          <h2>${escapeHtml(item.title)}</h2>
          <div class="prose">${item.body}</div>
          ${
            item.media.length
              ? `<div class="journal-media">${item.media.map((m) => renderMedia(m)).join("")}</div>`
              : ""
          }
        </div>
      </article>`
    )
    .join("");
}
